// extracted by mini-css-extract-plugin
export default {"sale-method-title":"SaleMethod__sale-method-title--TBpX3","saleMethodTitle":"SaleMethod__sale-method-title--TBpX3"};